<script>
import { Line } from 'vue-chartjs'
export default {
  extends: Line,

  props: {
    chartdata: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },

  data: function () {
  return {
    chart:'',
  };
},

  mounted () {
    console.log(this.chartdata)
    this.chart = this.chartdata;
    this.renderChart(this.chart, this.options)
  },

  watch: {
    chartdata: function (val) {
      this.chart = val
       this.renderChart(this.chart, this.options)
    }
  }


}
</script>
